module.exports = __webpack_public_path__ + "static/img/zgshehuizhuyi.72954037.jpg";